/* Staged only. Switch ENABLED after native paid-order adoption is verified. */
(function (scope) {
  'use strict';

  const ENABLED = true;
  const ENDPOINT = 'https://tryluvano.co/app/api/integrations/paysight/hosted-sessions';
  const HOST = 'checkout.tryluvano.co';
  const PRODUCT_ID = '13157';
  const OFFER_EXPERIMENT_ID = 'cinnamon-halloween-995-20261027';
  const OFFER_ORIGIN = 'https://tryluvano.co';
  const OFFER_PATH = '/app/api/integrations/paysight/cinnamon-offer';
  const WHOP_LANDING_KEY = 'lv_whop_landing_url_v1';
  const ROOT_FAMILY = {
    'luvanobaby.com': 'babyguard',
    'luvanosupps.com': 'cinnamon',
    'luvanopets.co': 'dog',
  };
  let pending = null;
  const cartSnapshots = new WeakMap();
  const PREPARE_MS = 15000;
  const TANNING_PATH = '/products/luvano-tanning-drops';
  const TANNING_VARIANTS = new Set(['67939845931195', '67939845963963', '67939845996731']);
  let prepared = null, preparing = null, preparePosts = 0, prepareGeneration = 0;

  function now() {
    try { return typeof scope.performance?.now === 'function' ? scope.performance.now() : null; }
    catch { return null; }
  }
  function rememberCartSnapshot(cart, url, raw) {
    if (!cart || typeof cart !== 'object' || typeof url !== 'string' || typeof raw !== 'string' || raw.length > 262144) return;
    const at = now();
    if (at === null || !Number.isFinite(at)) return;
    try {
      const serialized = JSON.stringify(cart);
      if (JSON.stringify(JSON.parse(raw)) !== serialized) return;
      cartSnapshots.set(cart, {url, raw, serialized, at});
    } catch { /* A fresh cart GET will be used. */ }
  }
  function takeCartSnapshot(cart, url) {
    if (!cart || typeof cart !== 'object') return null;
    const snapshot = cartSnapshots.get(cart);
    cartSnapshots.delete(cart);
    if (!snapshot) return null;
    const at = now();
    if (at === null || !Number.isFinite(at) || at - snapshot.at < 0 || at - snapshot.at > 1000 || snapshot.url !== url) return null;
    try {
      if (JSON.stringify(cart) !== snapshot.serialized) return null;
      return {raw: snapshot.raw, cart: JSON.parse(snapshot.raw)};
    } catch { return null; }
  }

  function cookie(name) {
    const pair = (scope.document?.cookie || '').split(';').map(value => value.trim())
      .find(value => value.startsWith(name + '='));
    if (!pair) return null;
    try { return decodeURIComponent(pair.slice(name.length + 1)); }
    catch { return null; }
  }
  function whopVisitor() {
    let value = cookie('_wuid');
    if (!value) try { value = scope.localStorage?.getItem('_wuid'); } catch { /* Optional. */ }
    return typeof value === 'string' && value.length <= 256 && /^[A-Za-z0-9._~-]+$/.test(value) ? value : null;
  }
  function whopLanding() {
    let value;
    try { value = scope.sessionStorage?.getItem(WHOP_LANDING_KEY); } catch { /* Optional. */ }
    if (typeof value !== 'string' || value.length > 2048) return null;
    try {
      const url = new URL(value);
      return url.origin === scope.location.origin && !url.username && !url.password && !url.hash ? value : null;
    } catch { return null; }
  }
  function lineTuple(line) {
    return [String(line?.variant_id ?? line?.id ?? ''), String(line?.product_id ?? ''), Number(line?.quantity), Number(line?.final_line_price), String(line?.key ?? '')];
  }
  function samePreparedCart(prepared, fresh) {
    if (!prepared || !fresh || prepared.currency !== 'USD' || fresh.currency !== 'USD' ||
        prepared.token !== fresh.token || prepared.total_price !== fresh.total_price ||
        !Array.isArray(prepared.items) || !Array.isArray(fresh.items) || prepared.items.length !== fresh.items.length) return false;
    return prepared.items.every((line, index) => JSON.stringify(lineTuple(line)) === JSON.stringify(lineTuple(fresh.items[index])));
  }
  async function realCartJson(cartUrl, signal) {
    const response = await scope.fetch(cartUrl, {method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}, ...(signal ? {signal} : {})});
    if (!response.ok) throw new Error('Cart could not be confirmed.');
    const raw = await response.text();
    if (raw.length > 262144) throw new Error('Cart could not be confirmed.');
    let cart;
    try { cart = JSON.parse(raw); } catch { throw new Error('Cart could not be confirmed.'); }
    return {raw, cart};
  }
  function validatedOfferDestination(result, cart, expectedFamily) {
    if (result?.kind !== 'cinnamon_offer' || result?.experimentId !== OFFER_EXPERIMENT_ID || result?.variant !== 'B' ||
        result?.productId !== 13157 || result?.family !== 'cinnamon' || expectedFamily !== 'cinnamon' ||
        result?.checkoutKind !== 'recurring' || result?.currency !== 'USD' ||
        result?.originalAmountCents !== 899 || result?.productCents !== 995 ||
        result?.standardTotalCents !== 1490 || result?.expressTotalCents !== 1990 ||
        cart?.currency !== 'USD' || cart?.total_price !== 899 ||
        !Array.isArray(cart.items) || cart.items.length !== 3 || typeof result?.url !== 'string') throw new Error('Checkout offer changed.');
    const expectedLines = new Map([['48370856132795', 0], ['48380075868347', 899], ['48376494653627', 0]]);
    for (const line of cart.items) {
      const variant = String(line?.variant_id ?? line?.id ?? '');
      if (!expectedLines.has(variant) || line.quantity !== 1 || line.final_line_price !== expectedLines.get(variant)) throw new Error('Checkout offer changed.');
      if (variant === '48370856132795' && String(line.product_id) !== '8544835895483') throw new Error('Checkout offer changed.');
      expectedLines.delete(variant);
    }
    if (expectedLines.size) throw new Error('Checkout offer changed.');
    let url;
    try { url = new URL(result.url); } catch { throw new Error('Checkout offer is unavailable.'); }
    const token = url.searchParams.get('token') || '';
    if (url.origin !== OFFER_ORIGIN || url.pathname !== OFFER_PATH || url.port || url.username || url.password || url.hash ||
        !/^[A-Za-z0-9_-]{43}$/.test(token) || [...url.searchParams.keys()].length !== 1 ||
        result.url !== OFFER_ORIGIN + OFFER_PATH + '?token=' + token) throw new Error('Checkout offer is unavailable.');
    return result.url;
  }
  function validatedDestination(result, cart, expectedFamily) {
    const sessionId = String(result?.sessionId ?? '');
    if (!/^[A-Za-z0-9_-]{8,200}$/.test(sessionId) || String(result?.productId) !== PRODUCT_ID ||
        result?.family !== expectedFamily || result?.currency !== 'USD' ||
        result?.amountCents !== cart.total_price ||
        result?.checkoutKind !== (expectedFamily === 'sport' ? 'one_time' : 'recurring') ||
        typeof result?.url !== 'string') throw new Error('Checkout details changed.');
    let url;
    try { url = new URL(result.url); } catch { throw new Error('Checkout destination is unavailable.'); }
    if (url.protocol !== 'https:' || url.hostname !== HOST || url.port || url.username || url.password || url.hash ||
        url.pathname !== '/' + sessionId || url.searchParams.get('spf_cur') !== 'USD' ||
        url.searchParams.get('currency_code') !== 'USD' ||
        !/^[0-9a-f-]{36}$/i.test(url.searchParams.get('pssid') || '') ||
        !/^[0-9a-f]{32}$/i.test(url.searchParams.get('ps_attempt_id') || '')) throw new Error('Checkout destination is unavailable.');
    // Return the original provider string. Rebuilding it breaks card iframe initialization.
    return result.url;
  }
  function canonical(value) {
    if (Array.isArray(value)) return value.map(canonical);
    if (value && typeof value === 'object') return Object.fromEntries(Object.keys(value).sort().map(key => [key, canonical(value[key])]));
    return value;
  }
  function eligibleTanning(cart) {
    if (cart?.currency !== 'USD' || !Number.isInteger(cart.total_price) || cart.total_price <= 0 ||
        cart.total_discount !== 0 || !Array.isArray(cart.items) || cart.items.length < 2 ||
        (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length) ||
        (Array.isArray(cart.discount_applications) && cart.discount_applications.length)) return false;
    let app = 0, quantity = 0;
    for (const line of cart.items) {
      const variant = String(line?.variant_id ?? line?.id ?? '');
      if (line?.discounts?.length || line?.discount_allocations?.length || line?.line_level_discount_allocations?.length ||
          line?.discount_applications?.length || line?.selling_plan_allocation || line?.selling_plan || line?.selling_plan_id) return false;
      if (variant === '48376494653627') {
        if (++app !== 1 || line.quantity !== 1 || line.final_line_price !== 0) return false;
      } else {
        if (!TANNING_VARIANTS.has(variant) || String(line.product_id) !== '15444890714299' ||
            !Number.isInteger(line.quantity) || line.quantity < 1 || !Number.isInteger(line.final_line_price) || line.final_line_price <= 0) return false;
        quantity += line.quantity;
      }
    }
    return app === 1 && quantity >= 1 && quantity <= 12;
  }
  function tanningOptions(options) {
    return scope.location.origin === 'https://tryluvano.co' && scope.location.pathname === TANNING_PATH &&
      options?.expectedFamily === 'cinnamon' && options?.pagePath === TANNING_PATH && options?.cartUrl === '/cart.js';
  }
  function request(raw, cart, path, options) {
    const landing = new URL(scope.location.href);
    landing.hash = '';
    const payload = {cartJson: raw, pagePath: path, landingPage: landing.toString(), cinnamonOfferProtocol: 1};
    const visitorId = whopVisitor(), whopLandingUrl = whopLanding();
    if (visitorId) payload.whopVisitorId = visitorId;
    if (whopLandingUrl) payload.whopLandingUrl = whopLandingUrl;
    if (typeof options?.eventToken === 'string' && options.eventToken.length <= 512) payload.eventToken = options.eventToken;
    const key = JSON.stringify(canonical({origin: scope.location.origin, page: scope.location.pathname, family: options?.expectedFamily,
      cartUrl: options?.cartUrl, cart, context: {...payload, cartJson: undefined}}));
    return {payload, key};
  }
  async function session(payload, cart, family, signal) {
    const response = await scope.fetch(ENDPOINT, {method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(payload), signal});
    if (!response.ok) throw new Error('Hosted checkout is temporarily unavailable.');
    let result;
    try { result = await response.json(); } catch { throw new Error('Hosted checkout is temporarily unavailable.'); }
    return result?.kind === 'cinnamon_offer'
      ? validatedOfferDestination(result, cart, family)
      : validatedDestination(result, cart, family);
  }
  function invalidatePrepared() {
    prepareGeneration++;
    prepared = null;
    if (preparing?.abort) preparing.abort();
  }
  function within(at) {
    const current = now();
    return Number.isFinite(current) && Number.isFinite(at) && current >= at && current - at < PREPARE_MS;
  }
  function prepare(uiCart, options) {
    const at = now();
    if (!ENABLED || !tanningOptions(options) || pending || preparing || preparePosts >= 2 || !Number.isFinite(at) || !eligibleTanning(uiCart)) return false;
    const generation = ++prepareGeneration;
    prepared = null;
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    let timer;
    const operation = {generation, abort: () => { try { controller?.abort(); } catch {} }};
    preparing = operation;
    const work = (async () => {
      const {raw, cart} = await realCartJson('/cart.js', controller?.signal);
      if (prepareGeneration !== generation || !within(at) || !samePreparedCart(uiCart, cart) || !eligibleTanning(cart) || !tanningOptions(options)) return false;
      const built = request(raw, cart, TANNING_PATH, options);
      preparePosts++;
      const entry = {key: built.key, at, generation, destination: null};
      prepared = entry;
      const destination = await session(built.payload, cart, 'cinnamon', controller?.signal);
      if (prepared !== entry || prepareGeneration !== generation || !within(at)) return false;
      entry.destination = destination;
      return true;
    })().catch(() => false).finally(() => { if (preparing === operation) preparing = null; });
    operation.promise = Promise.race([work, new Promise(resolve => { timer = setTimeout(() => {
      if (prepareGeneration === generation) invalidatePrepared();
      operation.abort(); resolve(false);
    }, PREPARE_MS); })])
      .then(value => {
        if (!value && prepared?.generation === generation) prepared = null;
        return value;
      }).catch(() => false).finally(() => { clearTimeout(timer); });
    return operation.promise;
  }
  async function start(preparedCart, options) {
    if (!ENABLED) throw new Error('Hosted checkout is not released.');
    if (pending) return pending;
    pending = (async () => {
      const family = options?.expectedFamily;
      const path = options?.pagePath ?? scope.location.pathname;
      const cartUrl = options?.cartUrl ?? '/cart.js';
      if (!['babyguard', 'cinnamon', 'dog', 'sport'].includes(family) || !path.startsWith('/') || !cartUrl.startsWith('/') || cartUrl.startsWith('//')) throw new Error('Checkout page is unavailable.');
      let {raw, cart} = takeCartSnapshot(preparedCart, cartUrl) || await realCartJson(cartUrl);
      if (!samePreparedCart(preparedCart, cart)) throw new Error('Cart changed. Please review it and try again.');
      let built = request(raw, cart, path, options), destination = null;
      if (tanningOptions(options) && eligibleTanning(cart)) {
        const active = preparing;
        const entry = prepared;
        const matching = entry && entry.key === built.key && entry.generation === prepareGeneration &&
          within(entry.at) && (!active || active.generation === entry.generation);
        if ((active || entry) && !matching) invalidatePrepared();
        if (active && matching) await active.promise;
        const usable = matching && prepared === entry && entry.destination &&
          entry.generation === prepareGeneration && within(entry.at);
        prepared = null;
        if (usable) {
          const current = request(raw, cart, path, options);
          if (current.key === entry.key && within(entry.at)) destination = entry.destination;
          else {
            const confirmed = await realCartJson(cartUrl);
            if (!samePreparedCart(preparedCart, confirmed.cart)) throw new Error('Cart changed. Please review it and try again.');
            raw = confirmed.raw; cart = confirmed.cart;
            built = request(raw, cart, path, options);
          }
        } else if (entry || active) {
          const confirmed = await realCartJson(cartUrl);
          if (!samePreparedCart(preparedCart, confirmed.cart)) throw new Error('Cart changed. Please review it and try again.');
          raw = confirmed.raw; cart = confirmed.cart;
          built = request(raw, cart, path, options);
        }
      }
      if (!destination) destination = await session(built.payload, cart, family, AbortSignal.timeout(65000));
      try {
        if (typeof options?.onInitiatedCheckout === 'function') options.onInitiatedCheckout();
        else scope.whop?.track?.('initiate_checkout');
      } catch { /* Tracking does not block checkout. */ }
      scope.location.assign(destination);
      return destination;
    })().finally(() => { pending = null; });
    return pending;
  }

  scope.LuvanoNativeHosted = {enabled: ENABLED, start, rememberCartSnapshot, preparationVersion: 1, prepare, invalidatePrepared};
  try {
    if (ENABLED && scope.location.origin === 'https://tryluvano.co' && scope.document?.head) {
      for (const origin of ['https://checkout.tryluvano.co', 'https://ui-components.evervault.com']) {
        const links = scope.document.head.querySelectorAll('link[rel~=preconnect]');
        if ([...links].some(link => { try { return new URL(link.href, scope.location.href).origin === origin; } catch { return false; } })) continue;
        const link = scope.document.createElement('link');
        link.rel = 'preconnect';
        link.href = origin;
        scope.document.head.appendChild(link);
      }
    }
  } catch { /* Connection hints are optional. */ }
  if (ENABLED && ROOT_FAMILY[scope.location.hostname] && scope.LuvanoPaysight) {
    scope.LuvanoPaysight.start = cart => start(cart, {
      expectedFamily: ROOT_FAMILY[scope.location.hostname],
      pagePath: scope.location.pathname,
      cartUrl: '/cart.js',
      eventToken: scope.token,
    });
  }
})(window);
